import moment from 'moment'
import React from 'react'
import {Badge, Card, Col, Container, Row} from 'react-bootstrap'

interface Props {
  grupos: Record<string, any>[]
  historial: Record<string, any>[]
}

const DetalleNivelContent: React.FC<Props> = (props) => {
  return (
    <Container>
      <Row className='g-4 mb-4'>
        {props.grupos.map((grupo, idx) => {
          const isLastOdd = props.grupos.length % 2 !== 0 && idx === props.grupos.length - 1
          return (
            <Col md={isLastOdd ? 12 : 6} key={grupo._id}>
              <Card className='h-100 shadow-sm'>
                <Card.Body>
                  <Card.Title className='mb-3 text-primary' style={{fontWeight: 700}}>
                    {grupo.detalle.grupoaprobacion.toUpperCase()}
                  </Card.Title>
                  <div className='d-flex flex-wrap gap-4 mb-0 ps-3'>
                    {grupo.detalle.responsables.map((user: any) => (
                      <span key={user.id} style={{fontSize: '1rem'}}>
                        <Badge bg='secondary' className='me-2'>
                          {user.nombre[0]}
                        </Badge>
                        {user.nombre}
                      </span>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )
        })}
      </Row>
      <Row>
        <Col>
          <h3 className='mb-3'>Historial</h3>
          {props.historial != null && props.historial.length > 0 ? (
            props.historial.map((historial: any, index: number) => (
              <Card
                key={index}
                className='mb-3 shadow-sm'
                border={historial.estado === 'rechazado' ? 'danger' : 'success'}
              >
                <Card.Body>
                  <div className='mb-2'>
                    <Badge bg={historial.estado === 'rechazado' ? 'danger' : 'success'}>
                      {historial.estado.toUpperCase()}
                    </Badge>
                  </div>
                  <div className='mb-1'>
                    <strong>Nivel:</strong>{' '}
                    {props.grupos.findIndex((n: any) => n._id === historial.idLevel) + 1}
                  </div>
                  <div className='mb-1'>
                    <strong>
                      {historial.estado === 'rechazado' ? 'Rechazado por:' : 'Aprobado por:'}
                    </strong>{' '}
                    {historial.username}
                  </div>
                  <div className='mb-1'>
                    <strong>Fecha:</strong> {moment(historial.fecha).format('DD/MM/YYYY H:mm')}
                  </div>
                  {historial.motivo != null && (
                    <div className='mb-1'>
                      <strong>Motivo:</strong> {historial.motivo}
                    </div>
                  )}
                </Card.Body>
              </Card>
            ))
          ) : (
            <Card className='text-center text-muted'>
              <Card.Body>Sin historial</Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export {DetalleNivelContent}
